import React, { useState } from "react";
import ParentNavBar from "./Navbar/ParenComponent";
import GradientWrapper from "./GradientWrapper/GradientWrapper";
import Footer from "./Footer/Footer";
import "./Contact.css";
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import {
  Email,
  Phone,
  Facebook,
  Instagram,
  Business,
  LocationCity,
  LocationOn,
  Person,
} from "@mui/icons-material";
import Logo from "./Navbar/logo/logo";
import { useSelector } from "react-redux";
import { SendContactForm, url } from "../Constants/api";
import { errorToast, successToast } from "../Constants/Toast";

const Contact = () => {
  return (
    <>
      <GradientWrapper isDisplayFlex={true}>
        <ParentNavBar />
        <div
          style={{
            marginTop: 150,
            gap: 40,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexDirection: "column",
            paddingBottom: 40,
          }}
        >
          <ContactDetails />
          <ContactForm />
        </div>
      </GradientWrapper>
      <Footer />
    </>
  );
};

export default Contact;
function ContactDetails() {
  return (
    <Container
      style={{
        flex: 1,
        minWidth: 300,
      }}
    >
      <Box
        sx={{
          padding: 4,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          minWidth: 300,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          fontFamily={"Montserrat, sans-serif"}
        >
          Contact Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <div
                style={{
                  alignSelf: "center",
                }}
              >
                <p style={{}} className="logoContact">
                  English
                </p>
                <p style={{}} className="logoContact">
                  Productions
                </p>
              </div>
              {/* <Typography variant="body1">English Productions</Typography> */}
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <Box display="flex" alignItems={"center"}>
              <LocationOn sx={{ mr: 1 }} />
              <Typography variant="subtitle1" fontFamily={"Montserrat"}>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  London, England
                </p>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  Port Macquarie, Australia
                </p>
              </Typography>
            </Box>
          </Grid> */}
          {/* <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Business sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat"}>
                Film Production
              </Typography>
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Person sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat, sans-serif"}>
                Sharron Aubrey (CEO, Actor, Screenwriter, Producer)
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Email sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat, sans-serif"}>
                <Link href="mailto:englishproductions@hotmail.com">
                  englishproductions@hotmail.com
                </Link>
              </Typography>
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Phone sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat"}>
                <Link href="tel:0265831614" aria-label="Phone">
                  0265831614
                </Link>
              </Typography>
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Facebook sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat, sans-serif"}>
                <Link
                  href="https://www.facebook.com/sharron.aubrey.5"
                  target="_blank"
                >
                  Sharron Aubrey
                </Link>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Instagram sx={{ mr: 1 }} />
              <Typography variant="body1" fontFamily={"Montserrat, sans-serif"}>
                <Link
                  href="https://www.instagram.com/english_productions_?igshid=mzrlodbinwflza"
                  target="_blank"
                >
                  @english_productions_
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

const ContactForm = () => {
  const userData = useSelector((state) => state.user);

  const [form, setForm] = useState({
    name: userData.email ? userData.email.split("@")[0] : "",
    email: userData.email || "",
    message: "",
    subject: "",
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    tempErrors.name =
      form.name.length < 10 ? "Name must be at least 10 characters long." : "";
    tempErrors.email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)
      ? ""
      : "Email is not valid.";
    tempErrors.message = form.message ? "" : "Message is required.";
    tempErrors.subject = form.subject ? "" : "Subject is required.";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      SendContactForm({
        email: form.email,
        message: form.message,
        name: form.name,
        subject: form.subject,
      })
        .then((res) => {
          successToast("Message sent successfully");
          setForm({
            email: "",
            message: "",
            name: "",
          });
        })
        .catch(() => {
          errorToast("There was some problem, please try again");
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  return (
    <Container
      //   maxWidth="sm"
      style={{
        flex: 1,
        minWidth: 300,
        fontFamily: "Montserrat",
      }}
    >
      <Box
        sx={{
          padding: 4,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          minHeight: 485,
          minWidth: 300,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          fontFamily={"Montserrat"}
        >
          Contact Us
        </Typography>
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="name"
                label="Name"
                value={form.name}
                onChange={handleChange}
                {...(errors.name && { error: true, helperText: errors.name })}
                style={{
                  fontFamily: "Montserrat",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="email"
                label="Email"
                value={form.email}
                onChange={handleChange}
                {...(errors.email && { error: true, helperText: errors.email })}
                style={{
                  fontFamily: "Montserrat",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="subject"
                label="Subject"
                value={form.subject}
                onChange={handleChange}
                {...(errors.subject && {
                  error: true,
                  helperText: errors.subject,
                })}
                style={{
                  fontFamily: "Montserrat",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="message"
                label="Message"
                multiline
                rows={4}
                value={form.message}
                onChange={handleChange}
                {...(errors.message && {
                  error: true,
                  helperText: errors.message,
                })}
                style={{
                  fontFamily: "Montserrat",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="submit" variant="contained" color="primary">
                  <Typography fontFamily={"Montserrat, sans-serif"}>
                    Send
                  </Typography>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Container>
  );
};
